import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {ClientHeader} from "./ClientHeader";
import {ClientTabs} from "./ClientTabs";

export class ClientAppContentContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            clientData: null,
            name: null
        };
    }

    componentDidMount() {
        this.updateClientData();
    }

    updateClientData() {
        new APIClient(API_URL + 'apps/'+this.props.appHash+'/client/'+this.props.clientId+'/').call('GET').then((data) => {
            if (data.status !== 'OK') {
                alert(data['error_message']);
            } else {
                this.setState({
                    name: data.data.name,
                    clientData: data.data.json_data,
                    loading: false
                });
            }
        })
    }

    render() {
        return (
            <section className="section-content">
                <ClientHeader name={this.state.name}/>
                <ClientTabs clientId={this.props.clientId} />
                <div className="section-body h-items" style={{paddingBottom: '0em'}}>
                    {this.renderContent()}
                </div>
            </section>
        )
    }

    renderClientData() {
        if(!this.state.clientData)
            return "No se encontró información del cliente";

        return Object.entries(JSON.parse(this.state.clientData)).map(([key, value]) => (
            <div className="form-group" key={key}>
                <label htmlFor={key}>{key}</label>
                <input type="text" className="form-control" value={value} readOnly />
            </div>
        ))
    }

    renderContent() {
        if (!this.state.loading) {
            return <div className="section-body-item -wider box">
                {/*<header className="box-header">*/}
                {/*    <h2 className="box-title">{this.state.name}</h2>*/}
                {/*</header>*/}
                {this.renderClientData()}
            </div>;
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderIncludedText(included) {
        if(included)
            return <span style={{color:"green", fontWeight:"bold" }}>-INCLUIDO-</span>;
        else
            return <span style={{color:"red", fontWeight:"bold" }}>-NO INCLUIDO-</span>;
    }
}
